// components/ActionModalWithModal.jsx  (final)
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import StaffActionModal from "components/StaffActionModal";
import { Link } from "react-router-dom";
import { encodeId } from "utils";
import { withTranslation } from "react-i18next";
import { forwardRef, useCallback, useMemo, useState } from "react";
import constants from "../../../../constants";
import staffRepository from "repositories/staff-repository";
import styles from "../../staff.module.scss";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { cloneDeep } from "lodash";
import {
  commonSelectedIntial,
  setterCommonValues,
} from "./staffActions.function";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import SelectOfficeActivationModal from "../modals/SelectOfficeActivationModal";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

const ActionModalWithModal = forwardRef(
  (
    {
      type,
      officeId,
      detail,
      officeData,
      t,
      globalStaffPage,
      selectedId,
      detailPage,
      staffActionsSubstitueActionSetter,
      resetApi,
    },
    ref,
  ) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const loadingSetter = (started) => {
      if (started) {
        dispatch({ type: "STAFFACTIONLOADINGSTARTED" });
      } else {
        dispatch({ type: "STAFFACTIONLOADINGSTOPPED" });
      }
    };
    const { isOwner, isStaff, profile, selectedOwnerIdString } =
      useAccountOwnerCommon();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(null); // holds either constants events or our custom strings
    const toggle = useCallback(() => setIsDropdownOpen((prev) => !prev), []);
    const {
      selectedActivated,
      selectedActivatedAdmin,
      selectedDeactivated,
      selectedDeactivatedAdmin,
      selectedActivatedAndDeactivate,
      selectedActivatedAndDeactivateAllAdmins,
      selectedInvitationPending,
      selectedInvitationDeclined,
      selectedRemoved,
    } = useMemo(() => {
      // staff {type}
      // 1=> activated
      // 2=> deactivated
      // 3=> invitation pending
      // 4=> invitation declined
      // 5=> removed
      const initalData = cloneDeep(commonSelectedIntial);
      if (globalStaffPage) {
        return detail.officeList.reduce((prev, curr) => {
          if (isStaff && curr.isAdmin) return prev;
          curr.staffMemberId = detail.userId;
          curr.firstName = detail.firstName;
          curr.lastName = detail.lastName;
          curr.profilePic = detail.profilePic;
          setterCommonValues(prev, curr);
          return prev;
        }, initalData);
      }
      return initalData;
    }, [detail, globalStaffPage, isStaff]);

    const userId = globalStaffPage ? detail.userId : detail.staffMemberId;

    const activateDeactivateStaff = async (isActive) => {
      loadingSetter(true);
      try {
        const payload = {
          UserIds: [userId],
          OfficeIds: globalStaffPage
            ? (isActive ? selectedDeactivated : selectedActivated).map(
                (res) => +res.officeId,
              )
            : [+officeId],
          OwnerId: selectedId,
          IsActive: isActive,
        };
        if (
          isActive &&
          globalStaffPage &&
          ((selectedDeactivated.length === 1 &&
            selectedDeactivatedAdmin.length === 0) ||
            (selectedDeactivated.length === 0 &&
              selectedDeactivatedAdmin.length === 1))
        ) {
          const userId = selectedDeactivatedAdmin[0]
            ? selectedDeactivatedAdmin[0].staffMemberId
            : selectedDeactivated[0].staffMemberId;
          const officeIdSend = selectedDeactivatedAdmin[0]
            ? selectedDeactivatedAdmin[0].officeId
            : selectedDeactivated[0].officeId;
          payload.UserIds = [userId];
          payload.OfficeIds = [officeIdSend];
        }

        const res =
          await staffRepository.bulkUpdateStatusActivateOrDeactivate(payload);
        if (res?.statusCode === 200) {
          toast.success(res.message);
          resetApi();
        }
        setIsModalOpen(null);
      } catch (error) {
        toast.error(error.message);
      } finally {
        loadingSetter(false);
      }
    };

    const removeStaff = async () => {
      loadingSetter(true);
      try {
        const payload = {
          UserIds: [userId],
          OwnerId: selectedId,
          OfficeIds: globalStaffPage
            ? selectedActivatedAndDeactivate.map((res) => +res.officeId)
            : [+officeId],
          IsGlobal: globalStaffPage,
        };
        const res = await staffRepository.bulkRemove(payload);
        if (res?.statusCode === 200) {
          toast.success(res.message);
          resetApi();
        }
        setIsModalOpen(null);
      } catch (error) {
        toast.error(error.message);
      } finally {
        loadingSetter(false);
      }
    };

    const onResendInviteOrNotifyClick = async (IsResendInvite) => {
      // IsResendInvite: true, for resend Invite
      // IsResendInvite: false, for re-notify
      loadingSetter(true);
      try {
        const payload = {
          OwnerId: selectedId,
          UserIds: [userId],
          IsGlobal: globalStaffPage,
          ...(globalStaffPage ? {} : { OfficeId: +officeId }),
          IsResendInvite: IsResendInvite,
        };
        const res = await staffRepository.renotifyPendingStaff(payload);
        if (res?.statusCode === 200) {
          toast.success(res.message);
          if (
            IsResendInvite &&
            (selectedRemoved.length > 0 || type === constants.staffType.removed)
          ) {
            resetApi();
          }
        }
        setIsModalOpen(null);
      } catch (error) {
        toast.error(error.message);
      } finally {
        loadingSetter(false);
      }
    };

    const onCancelRequest = async () => {
      loadingSetter(true);
      try {
        const requestQueryParams = `ownerId=${selectedId}&userId=${userId}${
          globalStaffPage
            ? selectedInvitationPending.reduce((prev, curr) => {
                prev += "&officeIds=" + curr.officeId;
                return prev;
              }, "")
            : "&officeIds=" + officeId
        }`;
        const res = await staffRepository.removeInvitations(requestQueryParams);
        if (res?.statusCode === 200) {
          toast.success(res.message);
          resetApi();
        }
        setIsModalOpen(null);
      } catch (error) {
        toast.error(error.message);
      } finally {
        loadingSetter(false);
      }
    };

    const onAction = () => {
      if (isModalOpen === constants.staffActionEvents.activation) {
        activateDeactivateStaff(true);
      } else if (isModalOpen === constants.staffActionEvents.deactivation) {
        activateDeactivateStaff(false);
      } else if (isModalOpen === constants.staffActionEvents.removal) {
        removeStaff();
      } else if (isModalOpen === constants.staffActionEvents.cancelInvitation) {
        onCancelRequest();
      } else {
        setIsModalOpen(null);
      }
    };

    const modalSetter = useCallback((val) => setIsModalOpen(val), []);

    const routeForDeactiveOrRemove = (search) => {
      const searchWithOwnerFilter =
        search +
        (globalStaffPage && selectedOwnerIdString
          ? `&${selectedOwnerIdString}`
          : "");

      history.push({
        pathname: globalStaffPage
          ? constants.routes.staff.globaleStaffDetail
          : constants.routes.staff.staffDetail,
        search: searchWithOwnerFilter,
        state: {
          detail: detail,
          OfficeId: officeId,
          officeData,
          ...(globalStaffPage && { ownerId: selectedId }),
        },
      });
    };
    const detailPageOrRedirectDeactivate = () => {
      if (detailPage) {
        staffActionsSubstitueActionSetter(
          constants.staffActionEvents.deactivation,
        );
      } else {
        routeForDeactiveOrRemove("?action=1");
      }
    };
    const onDeactivateStaffClick = () => {
      if (selectedActivated.length + selectedActivatedAdmin.length > 0) {
        if (
          selectedActivated.length === 0 &&
          selectedActivatedAdmin.length === 1
        ) {
          detailPageOrRedirectDeactivate();
        } else if (
          selectedActivated.length === 1 &&
          selectedActivatedAdmin.length === 0
        ) {
          modalSetter(constants.staffActionEvents.deactivation);
        } else {
          if (detailPage) {
            staffActionsSubstitueActionSetter(
              constants.staffActionEvents.multipleDeactivationConfirm,
            );
          } else {
            routeForDeactiveOrRemove("?action=1&isMultiple=true");
          }
        }
      } else if (!globalStaffPage && detail.isAdmin) {
        detailPageOrRedirectDeactivate();
      } else {
        modalSetter(constants.staffActionEvents.deactivation);
      }
    };
    const detailPageOrRedirectRemove = () => {
      if (detailPage) {
        staffActionsSubstitueActionSetter(constants.staffActionEvents.removal);
      } else {
        routeForDeactiveOrRemove("?action=2");
      }
    };
    const onRemoveStaffClick = () => {
      if (
        selectedActivatedAndDeactivate.length +
          selectedActivatedAndDeactivateAllAdmins.length >
        0
      ) {
        if (
          selectedActivatedAndDeactivate.length === 0 &&
          selectedActivatedAndDeactivateAllAdmins.length === 1
        ) {
          detailPageOrRedirectRemove();
        } else if (
          selectedActivatedAndDeactivate.length === 1 &&
          selectedActivatedAndDeactivateAllAdmins.length === 0
        ) {
          modalSetter(constants.staffActionEvents.removal);
        } else {
          if (detailPage) {
            staffActionsSubstitueActionSetter(
              constants.staffActionEvents.multipleRemoveConfirm,
            );
          } else {
            routeForDeactiveOrRemove("?action=2&isMultiple=true");
          }
        }
      } else if (!globalStaffPage && detail.isAdmin) {
        detailPageOrRedirectRemove();
      } else {
        modalSetter(constants.staffActionEvents.removal);
      }
    };

    const onActivateStaffClick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      if (selectedDeactivated.length + selectedDeactivatedAdmin.length > 0) {
        if (
          (selectedDeactivated.length === 1 &&
            selectedDeactivatedAdmin.length === 0) ||
          (selectedDeactivated.length === 0 &&
            selectedDeactivatedAdmin.length === 1)
        ) {
          modalSetter(constants.staffActionEvents.activation);
        } else {
          if (detailPage) {
            staffActionsSubstitueActionSetter(
              constants.staffActionEvents.multipleActivationConfirm,
            );
          } else {
            routeForDeactiveOrRemove("?action=3&isMultiple=true");
          }
        }
      } else {
        modalSetter(constants.staffActionEvents.activation);
      }
    };
    const onCancelStaffClick = () => {
      if (selectedInvitationPending.length > 0) {
        if (selectedInvitationPending.length === 1) {
          modalSetter(constants.staffActionEvents.cancelInvitation);
        } else {
          if (detailPage) {
            staffActionsSubstitueActionSetter(
              constants.staffActionEvents.multipleCancelConfirm,
            );
          } else {
            routeForDeactiveOrRemove("?action=4&isMultiple=true");
          }
        }
      } else {
        modalSetter(constants.staffActionEvents.cancelInvitation);
      }
    };
    const activatedStaffForEdit = isOwner
      ? [...selectedActivated, ...selectedActivatedAdmin]
      : selectedActivated;
    const isSingleOfficeModalOpened = isModalOpen === "singleOffice";
    const isMultipleOfficeModalOpened = isModalOpen === "multiOffice";
    const officeListForEdit =
      isSingleOfficeModalOpened || isMultipleOfficeModalOpened
        ? detail?.officeList?.filter(
            (res) =>
              [
                constants.staffType.activated,
                constants.staffType.invitationPending,
              ].includes(res?.type) && (isOwner ? true : !res?.isAdmin),
          )
        : [];

    const redirectionForEdit = (officeIds) => {
      const filteredData = officeListForEdit.filter((res) =>
        officeIds.includes(res.id),
      );
      if (officeIds.length === 1) {
        const value = filteredData[0];
        history.push({
          pathname: constants.routes.accountOwner.editStaff.replace(
            ":id",
            encodeId(value.officeId),
          ),
          state: {
            staffDetail: {
              staffMemberId: userId,
            },
            officeData: {
              ...(officeData || {}),
            },
          },
          ...(globalStaffPage && {
            search: selectedOwnerIdString ? `&${selectedOwnerIdString}` : "",
          }),
        });
      } else {
        history.push({
          pathname: constants.routes.accountOwner.updateStaffForMultipleOffices,
          state: {
            staffDetail: {
              staffMemberId: userId,
              selectedOfficeList: filteredData.map((res) => res.officeId),
            },
            ownerId: selectedId,
          },
          ...(globalStaffPage && {
            search: selectedOwnerIdString ? `&${selectedOwnerIdString}` : "",
          }),
        });
      }
    };
    const onEditOrUpdateClick = (cb) => {
      if (
        (activatedStaffForEdit.length === 1 &&
          selectedInvitationPending.length === 0) ||
        (activatedStaffForEdit.length === 0 &&
          selectedInvitationPending.length === 1)
      ) {
        const values = activatedStaffForEdit.length
          ? activatedStaffForEdit
          : selectedInvitationPending;
        history.push({
          pathname: constants.routes.accountOwner.editStaff.replace(
            ":id",
            encodeId(values[0].officeId),
          ),
          state: {
            staffDetail: {
              staffMemberId: userId,
            },
            officeData: {
              ...(officeData || {}),
            },
          },
          ...(globalStaffPage && {
            search: selectedOwnerIdString ? `&${selectedOwnerIdString}` : "",
          }),
        });
      } else {
        cb();
      }
    };
    const enabledEditForGlobal =
      globalStaffPage &&
      activatedStaffForEdit.length + selectedInvitationPending.length > 0;
    if (globalStaffPage && profile.id === detail?.userId) {
      return null;
    }
    if (
      globalStaffPage &&
      isStaff &&
      !selectedActivated.length &&
      !selectedDeactivated.length &&
      !selectedInvitationPending.length &&
      !selectedInvitationDeclined.length &&
      !selectedRemoved.length
    ) {
      return null;
    }
    return (
      <>
        <Dropdown
          isOpen={isDropdownOpen}
          toggle={toggle}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <DropdownToggle
            ref={ref}
            caret={false}
            tag="div"
            style={{
              padding: "4px 8px",
            }}
          >
            <span className="ico">
              <img
                src={require("assets/images/dots-icon.svg").default}
                alt="icon"
              />
            </span>
          </DropdownToggle>
          <DropdownMenu
            end
            className={styles["office-dropdown-menu"]}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            style={{ zIndex: 10 }}
            container={ref}
          >
            {globalStaffPage &&
              activatedStaffForEdit.length + selectedInvitationPending.length >
                1 && (
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={() => {
                    onEditOrUpdateClick(() => setIsModalOpen("multiOffice"));
                  }}
                >
                  <span>Update Across Offices</span>
                </DropdownItem>
              )}
            {(type === constants.staffType.activated ||
              type === constants.staffType.invitationPending ||
              enabledEditForGlobal) && (
              <DropdownItem
                className={styles["office-dropdown-item"]}
                onClick={(e) => {
                  if (globalStaffPage && enabledEditForGlobal) {
                    onEditOrUpdateClick(() => {
                      setIsModalOpen("singleOffice");
                    });
                  }
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                {globalStaffPage ? (
                  enabledEditForGlobal && <span>{t("edit")}</span>
                ) : (
                  <Link
                    to={{
                      pathname: constants.routes.accountOwner.editStaff.replace(
                        ":id",
                        encodeId(officeId),
                      ),
                      state: { staffDetail: detail, officeData },
                      search:
                        globalStaffPage && selectedOwnerIdString
                          ? `&${selectedOwnerIdString}`
                          : "",
                    }}
                  >
                    <span>{t("edit")}</span>
                  </Link>
                )}
              </DropdownItem>
            )}
            {/* {!type && ( */}
            <>
              {(type === constants.staffType.deactivated ||
                selectedDeactivated.length > 0 ||
                (isOwner && selectedDeactivatedAdmin.length > 0)) && (
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={onActivateStaffClick}
                >
                  <span>{t("accountOwner.activateStaff")}</span>
                </DropdownItem>
              )}
              {(selectedActivated.length > 0 ||
                (isOwner && selectedActivatedAdmin.length > 0) ||
                type === constants.staffType.activated) && (
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onDeactivateStaffClick();
                  }}
                >
                  <span>{t("accountOwner.deactivateStaff")}</span>
                </DropdownItem>
              )}
              {(selectedActivated.length > 0 ||
                (isOwner && selectedActivatedAdmin.length > 0) ||
                selectedDeactivated.length > 0 ||
                (isOwner && selectedDeactivatedAdmin.length > 0) ||
                type === constants.staffType.activated ||
                type === constants.staffType.deactivated) && (
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onRemoveStaffClick();
                  }}
                >
                  <span>{t("accountOwner.removeStaff")}</span>
                </DropdownItem>
              )}
              {(selectedInvitationPending.length > 0 ||
                type === constants.staffType.invitationPending) && (
                <>
                  <DropdownItem
                    className={styles["office-dropdown-item"]}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      onCancelStaffClick();
                    }}
                  >
                    <span>{t("accountOwner.cancelInvitation")}</span>
                  </DropdownItem>
                  <DropdownItem
                    className={styles["office-dropdown-item"]}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      onResendInviteOrNotifyClick(false);
                    }}
                  >
                    <span>{t("staff.renotify")}</span>
                  </DropdownItem>
                </>
              )}
              {(selectedInvitationPending.length > 0 ||
                selectedInvitationDeclined.length > 0 ||
                selectedRemoved.length > 0 ||
                type === constants.staffType.invitationDeclined ||
                type === constants.staffType.invitationPending ||
                type === constants.staffType.removed) && (
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onResendInviteOrNotifyClick(true);
                  }}
                >
                  <span>{t("staff.resendInvite")}</span>
                </DropdownItem>
              )}
            </>
          </DropdownMenu>
        </Dropdown>
        {(isSingleOfficeModalOpened || isMultipleOfficeModalOpened) && (
          <SelectOfficeActivationModal
            isOpen={true}
            offices={officeListForEdit}
            selectedOfficeIds={[]}
            titlePage={
              isSingleOfficeModalOpened
                ? "Select office to edit the details"
                : "Select office(s) to update the details"
            }
            radioEnabled={isSingleOfficeModalOpened}
            onClose={() => setIsModalOpen(false)}
            onSubmit={(officeIds) => {
              redirectionForEdit(officeIds);
            }}
            dontCheckAdmin
          />
        )}
        {[
          constants.staffActionEvents.activation,
          constants.staffActionEvents.deactivation,
          constants.staffActionEvents.removal,
          constants.staffActionEvents.removalAsAdmin,
          constants.staffActionEvents.cancelInvitation,
          constants.staffActionEvents.multipleActivationConfirm,
        ].includes(isModalOpen) && (
          <StaffActionModal
            isOpen={true}
            event={isModalOpen}
            onAction={onAction}
            onClose={() => modalSetter(null)}
          />
        )}
      </>
    );
  },
);

ActionModalWithModal.displayName = "ActionModalWithModal";

export default withTranslation()(ActionModalWithModal);
